import React, { useEffect } from "react";
import $ from 'jquery'

const NavTab = ({visible,setModalPopupContent,renderSliderScene}) => {

    useEffect(() => {
       
        setCheckedState("home1") 

        renderSliderScene("home1")

    },[])


    const[ checkedstate, setCheckedState]  = React.useState("home1")



    return(

        <div className="door_option_tab" style={visible ? { 'display' : 'block'} : {'display' : 'none' }} >
            <div className="tab-content" id="myTabContent">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  
                
                    <li className="nav-item">
                        <a className="nav-link " id="contact-tab" data-toggle="tab" href="#contact" role="tab"
                            aria-controls="contact" aria-selected="false"
                            onClick={(e) => {
                                $(".tab-content .nav-link").removeClass('event-block')

                                e.target.classList.add('event-block')
                                setCheckedState("livingroom") 
                                renderSliderScene("other_products")
                            }}
                            >Other Products</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                            aria-controls="profile" aria-selected="false"
                            onClick={(e) => {
                                $(".tab-content .nav-link").removeClass('event-block')

                                e.target.classList.add('event-block')
                                setCheckedState("livingroom") 
                                renderSliderScene("livingroom")
                            }}
                            >Fypon Interior Products</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link active event-block" id="home-tab" data-toggle="tab" href="#home" role="tab"
                            aria-controls="home" aria-selected="true"
                            onClick={(e) => {

                                $(".tab-content .nav-link").removeClass('event-block')
                                e.target.classList.add('event-block')

                                setCheckedState("home1") 

                                renderSliderScene("home1")

                            }}
                            >Fypon Exterior Products</a>
                    </li>
                </ul>
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <div className="door_option_div2 p-3">
                        <div className="row">
                            <div className="col-3">
                                <label className="redio_button mb-3">Home 1
                                    <input type="radio" value="home1" checked={checkedstate === "home1"}  onChange={e => { 
                                            setCheckedState("home1") 
                                            renderSliderScene("home1")
                                        }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="redio_button">Home 2
                                
                                    <input type="radio" value="home1" checked={checkedstate === "home2"}  onChange={e => { 
                                        setCheckedState("home2")
                                        renderSliderScene("home2")

                                    }} />

                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-9">
                                <div className="row">
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_new_pr_tr_video_get_inspred")}>Get Inspired</a>
                                    </div>
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_exterior_pr_tr_literature")}>Literature</a>
                                    </div>
                                    <div className="col-4">
                                    <a href="#" className="products_btn" onClick={() =>  window.open("https://fypon.com/collections/fypon-sample/sample","_blank") }>Fypon Sample Order</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <div className="door_option_div2 p-3">
                        <div className="row">
                            <div className="col-3">
                                <label className="redio_button mb-3">Living Room
                                
                                    <input type="radio" value="livingroom" checked={checkedstate === "livingroom"}  onChange={e => { 
                                        setCheckedState("livingroom")
                                        renderSliderScene("livingroom")

                                    }} />

                                    <span className="checkmark"></span>
                                </label>
                                <label className="redio_button">Foyer
                                <input type="radio" value="foyer" checked={checkedstate === "foyer"}  onChange={e => { 
                                    setCheckedState("foyer")
                                    renderSliderScene("foyer")

                                    }} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-9">
                                <div className="row">
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_inter_pr__get_inspred")}>Get Inspired</a>
                                    </div>
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_interior_pr_tr_literature")}>Literature</a>
                                    </div>
                                    <div className="col-4">
                                    <a href="#" className="products_btn" onClick={() =>  window.open("https://fypon.com/collections/fypon-sample/sample","_blank") }>Fypon Sample Order</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                    <div className="door_option_div2 w-75 float-right p-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_other_pr_tr_video_get_inspred")}>Get Inspired</a>
                                    </div>
                                    <div className="col-4 pr-0">
                                        <a href="#" className="products_btn" onClick={() => setModalPopupContent("explore_fypon_new_pr_tr_literature")}>Literature</a>
                                    </div>
                                    <div className="col-4">
                                        
                                        <a href="#" className="products_btn" onClick={() =>  window.open("https://fypon.com/collections/fypon-sample/sample","_blank") }>Fypon Sample Order</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NavTab;